import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { updateSegment } from '../../../redux/currentSearch/actions';
import {
    getRoundTripDateErrorsSelector,
    getSegments,
    isEditReturn,
    displayFaresInCalendar,
    getActiveProduct,
} from '../../../redux/currentSearch/selectors';
import { CurrentAccommodationSearchSessionStorage, DateUtils } from '../../../utils';
import { EntryPoint } from '../../../models';

const getDefaultSegment = (addValue = 0) => ({ id: Date.now() + addValue });
const calculateMinDate = (date, isEditReturn) => isEditReturn ? date : DateUtils.getToday();

export const SegmentDateRoundTrip = ({ children, segments, updateSegment, dateError, isEditReturn, displayFaresInCalendar, getActiveProduct }) => {
    const [firstSegment, secondSegment] = segments;
    const originSegment = firstSegment || getDefaultSegment(1);
    const destinationSegment = secondSegment || getDefaultSegment(2);
    const productsWithOneWayOffer = [EntryPoint.FLIGHTS, EntryPoint.TRAINS];

    if (!secondSegment && segments.length === 1) {
        segments.push(destinationSegment);
    }

    const dates = segments.map((s) => s.date);
    const originDate = originSegment.date;

    const [minDate, setMinDate] = React.useState(calculateMinDate(segments, isEditReturn));

    React.useEffect(() => {
        const { date } = originSegment;
        setMinDate(calculateMinDate(date, isEditReturn));
    }, [isEditReturn, originSegment]);

    React.useEffect(() => {
        const { id, date } = destinationSegment;
        if (date && DateUtils.compare(date, minDate) === 1) {
            updateSegment({ date: null }, id);
        }
    }, [destinationSegment, minDate, updateSegment]);

    const setValue = (date) => {
        const segment = isEditReturn ? destinationSegment : originSegment;
        const destinationId = destinationSegment.id;
        const { id } = segment;
        if (!isEditReturn) {
            updateSegment({ date: null }, destinationId);
        }
        updateSegment({ date }, id);
        CurrentAccommodationSearchSessionStorage.setDates({ id, date, segments });
    };

    return children({ error: dateError, dates, minDate, setValue, value: originDate, displayFaresInCalendar,
        offerOneWay: productsWithOneWayOffer.includes(getActiveProduct) });
};

SegmentDateRoundTrip.propTypes = {
    children: PropTypes.func.isRequired,
    displayFaresInCalendar: PropTypes.bool.isRequired,
    updateSegment: PropTypes.func.isRequired,
    getActiveProduct: PropTypes.string.isRequired,
};

const mapStateToPropsSelector = createStructuredSelector({
    segments: getSegments,
    dateError: getRoundTripDateErrorsSelector,
    displayFaresInCalendar,
    isEditReturn,
    getActiveProduct,
});

export const ConnectedSegmentDateRoundTrip = connect(mapStateToPropsSelector, {
    updateSegment,
})(SegmentDateRoundTrip);
